export default "__VITE_ASSET__BkEjjzQH__"